import TypeToReducer from 'type-to-reducer';

import { normalize, schema } from 'normalizr';

import {
  GET_PROJECTS,
  SET_PROJECTS_PAGINATION,
  SET_PROJECTS_FILTERS,
  RESET_PROJECTS,
  TOGGLE_PROJECT,
} from 'projects/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

export const project = new schema.Entity('projects');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'amount'],
    // columnSearch: ["key", "name"],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { projects: {} },
  result: { projects: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ projects: payload.records }, { projects: [project] });

  return { ...state, isLoading: false, pagination, ...normalized };
};
export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    projects: {
      ...state.entities.projects,
      [meta.id]: { ...state.entities.projects[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    projects: {
      ...state.entities.projects,
      [meta.id]: { ...state.entities.projects[meta.id], isLoading: true },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    projects: {
      ...state.entities.projects,
      [payload.project.id]: { ...payload.project, isLoading: false },
    },
  },
});

const projectsListReducers = {
  [GET_PROJECTS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_PROJECTS_PAGINATION]: setPagination,
  [SET_PROJECTS_FILTERS]: setFilters,
  [RESET_PROJECTS]: reset,
  [TOGGLE_PROJECT]: {
    [PENDING]: togglePending,
    [REJECTED]: toggleRejected,
    [FULFILLED]: toggleFulfilled,
  },
};

export default TypeToReducer(projectsListReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/reducers/projects_list_reducers.js